// Lazy Load Directive

export default {
    inserted: el => {

        function loadImage () {
            console.log(el.dataset)
            el.src = el.dataset.url
            el.classList.add('loaded')
            console.log(el.classlist)
        }

        function handleIntersect (entries, observer) {
           entries.forEach (entry => {
               if(entry.isIntersecting){
                    loadImage()
                    observer.unobserve(el)
                console.log('Is Intersecting')
                // console.log(entry.target)
               }
                
           })
        }

        function createObserver(){
            console.log('Create the observer')
            let options = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0
            }

            let observer = new IntersectionObserver(handleIntersect, options)
            observer.observe(el)
        }

        if (window["IntersectionObserver"]) {
            createObserver();
          } else {
            loadImage();
          }
    }
};